import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { Teacher, TeachersWebType, TeacherWeb, TeacherWebCreateEdit } from "../../types/slices/teachersWebType";

const initialState: TeachersWebType = {
  status: ApiStatus.FETCHED,
  teachersWeb: [] as TeacherWeb[],
  errorMessage: undefined,
  editTeacherWeb: {} as TeacherWebCreateEdit,
  selectedTeacherWeb: {} as TeacherWeb,
  selectedTeacher: {} as Teacher,
  teachers: [],
  openModal: false,
  isEdit: false,
};

const teacherWebSlice = createSlice({
  name: "teacherWeb",
  initialState,
  reducers: {
    onFetchTeachersWeb(state, { payload }: { payload: TeacherWeb[] }) {
      state.status = ApiStatus.FETCHED;
      state.teachersWeb = payload;
      state.errorMessage = undefined;
    },
    onFetchTeachers(state, { payload }: { payload: Teacher[] }) {
      state.status = ApiStatus.FETCHED;
      state.teachers = payload;
      state.errorMessage = undefined;
    },
    changeStatus(state, { payload }: { payload: ApiStatus }) {
      state.status = payload;
    },
    onSetEditTeacherWeb(state, { payload }: { payload: TeacherWebCreateEdit }) {
      state.editTeacherWeb = payload;
    },
    onSetSelectedTeacherWeb(state, { payload }: { payload: TeacherWeb }) {
      state.selectedTeacherWeb = payload;
    },
    onSetSelectedTeacher(state, { payload }: { payload: Teacher }) {
      state.selectedTeacher = payload;
    },
    onSetOpenModal(state, { payload }: { payload: boolean }) {
      state.openModal = payload;
    },
    onChangeIsEdit(state, { payload }: { payload: boolean }) {
      state.isEdit = payload;
    },
  },
});

export const selectTeacherWebState = (state: RootState) => state.teacherWebSlice;
export default teacherWebSlice.reducer;

export const {
  onFetchTeachersWeb,
  changeStatus,
  onSetEditTeacherWeb,
  onSetSelectedTeacherWeb,
  onSetSelectedTeacher,
  onSetOpenModal,
  onChangeIsEdit,
  onFetchTeachers,
} = teacherWebSlice.actions;